export class ClaimWithSourceAndTagIds {
  RawDataImport_ShardClaimIdentifier: number;
  Source: string;
  TagIds: number[];
}
